import { type FC } from 'react';
import BaseLayout from '@/base/Layout';
import BaseLayoutBody from '@/base/Layout/Body';
import AdminSideNav from '@/account/component/Layout/SideNav';
import SmartWindow from '@/base/Layout/SmartWindow';
import { UiHStack, UiStack } from '@/lib/ui';
import UserTable from './UserTable';
import BaseLayoutFullScreenToggle from '@/base/Layout/FullScreenToggle';
import { useTenantRoute } from '@/account/hook/useTenantRoute';

const AccountAccessUsersPage: FC = () => {
  const { tenantCode, tenant } = useTenantRoute();
  
  return (
    <BaseLayout
      smartWindow={(<SmartWindow />)}
      sideMenu={(<AdminSideNav activeNodes={['userAccess', 'tenantUsers']} />)}
      appSwitch={(<UiHStack flexGrow={1} />)}
    >
      <BaseLayoutBody
        isStandalone={false}
      >
        <UiStack spacing={4}>
          <UiHStack justifyContent={'flex-start'} spacing={4}>
            <BaseLayoutFullScreenToggle />
          </UiHStack>
          <UserTable />
        </UiStack>
      </BaseLayoutBody>
    </BaseLayout>
  );
};

export default AccountAccessUsersPage;